var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM6.125 3.79167C6.125 3.30842 6.51675 2.91667 7 2.91667C7.48325 2.91667 7.875 3.30842 7.875 3.79167V8.45833C7.875 8.94158 7.48325 9.33333 7 9.33333C6.51675 9.33333 6.125 8.94158 6.125 8.45833V3.79167ZM6.125 10.7917C6.125 10.3085 6.51675 9.91671 7 9.91671C7.48325 9.91671 7.875 10.3085 7.875 10.7917C7.875 11.275 7.48325 11.6667 7 11.6667C6.51675 11.6667 6.125 11.275 6.125 10.7917Z",
    fill: "#C78186"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.c1959b685493b61a5a85e95cb8c4d415.svg";
export { ForwardRef as ReactComponent };